const favoriteUrl = `/api/favorites.json`;

// お気に入り取得
const getFavorite = (gymId) => {
  return $.ajax({
    url: favoriteUrl,
    type: "GET",
    dataType: "text",
    data: { gym_id: gymId },
  });
};

// お気に入り登録
const postFavorite = (gymId) => {
  return $.ajax({
    url: favoriteUrl,
    type: "POST",
    dataType: "json",
    data: { gym_id: gymId },
  });
};

// お気に入り解除
const deleteFavorite = (gymId) => {
  return $.ajax({
    url: favoriteUrl,
    type: "DELETE",
    dataType: "json",
    data: { gym_id: gymId },
  });
};

const favoriteButtonAction = async (ev) => {
  const gymId = $(ev.currentTarget).data("gymId");

  if ($(ev.currentTarget).hasClass("favorite")) {
    $(ev.currentTarget).removeClass("favorite");
    const deleteResult = await deleteFavorite(gymId);
    if (deleteResult.errors) {
      // UX優先でAPI結果を待たずに先にボタン状態を変化させているため、エラー時は戻す
      $(ev.currentTarget).addClass("favorite");
    }
  } else {
    $(ev.currentTarget).addClass("favorite");
    const postResult = await postFavorite(gymId);
    if (postResult.errors) {
      // UX優先でAPI結果を待たずに先にボタン状態を変化させているため、エラー時は戻す
      $(ev.currentTarget).removeClass("favorite");
    }
  }
};

$(function () {
  // ジム詳細画面
  const $gymDetail = $(".gymdetail-wrapper");
  const $favoriteButton = $($gymDetail).find(".gymdetail-img--favorite-button");

  // ジム詳細画面 ボタンクリック
  $($favoriteButton).on("click", (ev) => {
    const isLoggedIn = $(ev.currentTarget).data("isLoggedIn");
    const redirectUrl = $(ev.currentTarget).data("redirectUrl");
    if (isLoggedIn) {
      favoriteButtonAction(ev);
    } else {
      location.href = redirectUrl;
    }
  });
});

$(function () {
  // ジム一覧画面
  const $rentalGymItems = $(".rentalgym-item");
  for (let i = 0; i < $rentalGymItems.length; i++) {
    const $favoriteButton = $($rentalGymItems[i]).find(
      ".rentalgym-item--favorite-button"
    );
    $($favoriteButton).on("click", (ev) => {
      const isLoggedIn = $(ev.currentTarget).data("isLoggedIn");
      const redirectUrl = $(ev.currentTarget).data("redirectUrl");

      ev.stopPropagation();
      ev.preventDefault();

      if (isLoggedIn) {
        favoriteButtonAction(ev);
      } else {
        location.href = redirectUrl;
      }
    });
  }
});

// ブラウザバック時のリロード処理
$(window).off("popstate.backward");
$(() => {
  history.replaceState(
    null,
    document.getElementsByTagName("title")[0].innerHTML,
    null
  );
  $(window).on("popstate.backward", (ev) => {
    window.location.reload();
  });
});
